// import external dependencies
import 'jquery';

// Import everything from autoload


// Plugin importing
import 'slick-carousel/slick/slick.min';
import { library, dom } from '@fortawesome/fontawesome-svg-core';
import { faFacebook, faTwitter } from '@fortawesome/free-brands-svg-icons';
// import { fa } from '@fortawesome/free-regular-svg-icons';
import { faSearch, faCube, faChevronLeft, faChevronRight, faMapMarkerAlt, faCalendarAlt, faArchive, faLink, faHeart, faPlus } from '@fortawesome/free-solid-svg-icons';

import 'slick-carousel/slick/slick.min';
import '@fancyapps/fancybox/dist/jquery.fancybox.min'

// ThreeJS importing
import * as THREE from 'three'
window.THREE = THREE
import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader'
import Stats from 'three/examples/jsm/libs/stats.module'
import { GUI } from 'three/examples/jsm/libs/dat.gui.module'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'
window.OBJLoader = OBJLoader
window.Stats = Stats
window.GUI = GUI
window.OrbitControls = OrbitControls

// AFrame Importing
// import 'aframe'
// import * as AFRAME from 'aframe'
// window.AFRAME = AFRAME

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

library.add(faFacebook, faTwitter, faSearch, faCube, faChevronLeft, faChevronRight, faMapMarkerAlt, faCalendarAlt, faArchive, faLink, faHeart, faPlus);
dom.watch();

jQuery(function($){
  // Load Events
  routes.loadEvents()
  $('#loading').delay(1000).fadeOut()
  // Global scripts
  $(document).on('scroll', function(){
    let header = $('#header')
    if(window.pageYOffset > header[0].offsetHeight){
      header.addClass('sticked');
    }else{
      header.removeClass('sticked');
    }
  })
  $('#mobile-menu-toggle').on('click',function(){
    $('#mobile-menu').toggleClass('hidden').toggleClass('flex')
  })
  $('.menu-item-has-children').on('mouseover', function(){
    $(this).children('.sub-menu').addClass('active')
  }).on('mouseleave', function(){
    $(this).children('.sub-menu').removeClass('active')
  })
})

// Setup Modal functions
window.modal = {
  open(id) {
    var modal = document.getElementById(id)
    console.log(modal)
    modal.style.display = 'block'

    // When the user clicks anywhere outside of the modal, close it
    window.onclick = function(event) {
      if (event.target == modal) {
        jQuery('#'+id).fadeOut(500)
      }
    }
  },
  close(id) {
    jQuery('#'+id).fadeOut(500)
  },
};



// WEBPACK FOOTER //
// ./scripts/main.js